import PopularDestinationsContainerMobile from '../../../../components/containers/PopularDestinationsContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadPopularDestinationsProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'popular-destinations--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: PopularDestinationsContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
